// removed by extract-text-webpack-plugin
module.exports = {"banner":"app__css__app-pages-dormInfo-__index__banner","con_r":"app__css__app-pages-dormInfo-__index__con_r","top":"app__css__app-pages-dormInfo-__index__top","title":"app__css__app-pages-dormInfo-__index__title","sub":"app__css__app-pages-dormInfo-__index__sub","con":"app__css__app-pages-dormInfo-__index__con"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/dormInfo/index.css
// module id = 1577
// module chunks = 0